const parseToNumber = (value: string | number | null | undefined): number => {
  if (typeof value === 'string') {
    const sanitized = value.replace(/[^0-9.]/g, '');
    return parseFloat(sanitized) || 0;
  }
  return value || 0;
};

interface ICalculateFinalHeadWeightProps {
  headWeight: string | number | null;
  drill: string | number | null;
  tipPlug: string | number | null;
  glueWeight: string | number | null;
  leadTape: string | number | null;
}

// Formula: Final Head Weight = Head Weight - Drill Weight + Tip Plug + Glue + Lead Tape
export const calculateFinalHeadWeight = ({ headWeight, drill, tipPlug, glueWeight, leadTape }: ICalculateFinalHeadWeightProps) => {
  const headWeightNumber = parseToNumber(headWeight);
  const drillNumber = parseToNumber(drill);
  const tipPlugNumber = parseToNumber(tipPlug);
  const glueWeightNumber = parseToNumber(glueWeight);
  const leadTapeNumber = parseToNumber(leadTape);

  const finalHeadWeightValue = headWeightNumber - drillNumber + tipPlugNumber + glueWeightNumber + leadTapeNumber;

  return finalHeadWeightValue === 0 ? '---' : finalHeadWeightValue.toString();
};
